import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, Loader2, ShieldCheck } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/domium-ia/completion`;

export default function DevisCompletionPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [values, setValues] = useState({});
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    axios.get(`${API}/${token}`).then((r) => setData(r.data))
      .catch((e) => setError(e.response?.data?.detail || 'Lien invalide ou expiré'));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try { await axios.post(`${API}/${token}`, { values }); setDone(true); }
    catch (err) { setError(err.response?.data?.detail || "Erreur lors de l'envoi"); }
    finally { setSending(false); }
  };

  return (
    <main className="min-h-screen bg-slate-50 flex items-start justify-center py-16 px-4" data-testid="devis-completion-page">
      <div className="w-full max-w-xl bg-white rounded-2xl shadow-sm border border-slate-200 p-8 space-y-5">
        <div className="flex items-center gap-3">
          <ShieldCheck className="h-8 w-8 text-violet-600" />
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Compléter votre demande de devis</h1>
            <p className="text-sm text-slate-500">DOS DOMIUM — COPPAM Garanties Solidaires</p>
          </div>
        </div>
        {error && <p className="text-sm text-red-600 bg-red-50 rounded p-3" data-testid="completion-error">{error}</p>}
        {!data && !error && <Loader2 className="h-6 w-6 animate-spin text-violet-500" />}
        {done && (
          <p className="flex items-center gap-2 text-emerald-700 bg-emerald-50 rounded p-4" data-testid="completion-success">
            <CheckCircle2 className="h-5 w-5" /> Merci ! Vos informations ont été transmises et votre dossier a été mis à jour.
          </p>
        )}
        {data && !done && (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-slate-600">Dossier <strong>{data.reference}</strong>{data.demandeur && <> — {data.demandeur}</>}</p>
            {data.projet && <p className="text-xs text-slate-500 bg-slate-50 rounded p-3">{data.projet}</p>}
            {data.champs.length === 0 && <p className="text-sm text-emerald-700">Votre dossier est complet, aucune information supplémentaire n'est requise.</p>}
            {data.champs.map((c) => (
              <label key={c.key} className="block text-sm text-slate-700 space-y-1">
                <span>{c.label}</span>
                <Input type={c.type === 'number' ? 'number' : c.type} step="any" required value={values[c.key] ?? ''} onChange={(e) => setValues((v) => ({ ...v, [c.key]: e.target.value }))} data-testid={`completion-field-${c.key}`} />
              </label>
            ))}
            {data.champs.length > 0 && (
              <Button type="submit" disabled={sending} className="w-full bg-violet-600 hover:bg-violet-700 text-white" data-testid="completion-submit-btn">
                {sending ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null} Envoyer mes informations
              </Button>
            )}
          </form>
        )}
      </div>
    </main>
  );
}
